<template>
  <Modal v-model="showModal"
    scrollable
    :mask="true"
    :mask-closable="false"
    @on-cancel="closeModal"
    class="user-new"
    title="注册新用户">
    <Form ref="newForm" :model="userModel"
      :rules="modelValidate"
      label-position="left"
      :label-width="120">
      <FormItem label="姓名" prop="displayName">
        <Input v-model="userModel.displayName" placeholder="输入姓名" />
      </FormItem>
      <FormItem label="登录用户名" prop="loginName">
        <Input v-model="userModel.loginName" placeholder="输入登录用户名" />
      </FormItem>
      <FormItem label="登录密码" prop="password">
        <Input v-model="userModel.password" type="password" placeholder="输入登录密码" />
      </FormItem>
      <FormItem label="重复登录密码" prop="rePassword">
        <Input v-model="userModel.rePassword" type="password" placeholder="重复输入登录密码" />
      </FormItem>
      <FormItem label="手机号" prop="mobile">
        <Input v-model="userModel.mobile" placeholder="输入手机号" />
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="primary" @click="submit">提交</Button>
      <Button @click="closeModal">取消</Button>
    </div>
  </Modal>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'user-new',
  props: {
    show: Boolean
  },
  data () {
    const validateRepassword = (rule, value, callback) => {
      if (this.userModel.password && value !== this.userModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      showModal: false,
      loading: false,
      userModel: {
        displayName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: 3,
        certCn: null,
        roleId: null
      },
      modelValidate: {
        displayName: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        loginName: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      roles: []
    }
  },
  watch: {
    show: function (val) {
      this.showModal = val
    }
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    closeModal () {
      this.showModal = false
      this.$emit('on-close')
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.userModel.passwordMd5 = this.$md5(this.userModel.password)
          await Api.Auth(this).register(this.userModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.userModel= {
                displayName: null,
                password: null,
                rePassword: null,
                passwordMd5: null,
                gender: 1,
                loginName: null,
                enabled: true,
                mobile: null,
                email: null,
                type: 3,
                certCn: null,
                roleId: null
              }
              this.loading = false
              this.$Spin.hide()
              this.closeModal()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
    changeUserType (cur) {
      if (cur && this.roles && this.roles instanceof Array) {
        this.roles.forEach((r) => {
          if (r.type !== cur) {
            r.disabled = true
          } else {
            r.disabled = false
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  .student-avatar {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
  }
}
</style>
